import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardServices from "@/services/DashboardServices";
import DashboardInternalData from "@/internalData/Dashboard"
export default {
  name: "CommonInstructions",
  data() {
    return {
      isDisable: true,
      borderHeaderFields: DashboardInternalData.commonInstructions.borderHeaderFields,
      formatText: "rounded-0 cus-text-resize-0 border-0 w-100 p-2",
      formatTextExtra: "rounded-0 border-0 cus-format-cell-revision text-input-extra previous-element pb-2",
      formatTextExtraLastest: "rounded-0 border-0 extra-input text-input-extra cus-text-area-border"
    };
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    commonsRecord() {
      let commons = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].commons;
      if (commons != undefined) {
        return commons;
      }
    },
  },
  methods: {
    setCommonsRecords(path, value) {
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + path, value: value });
      this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
    focusInCommons(attr, status) {
      let obj = { attr: attr, status: status };
      this.$store.commit(DashboardConstants.COMMIT.changeStatusFocusCommons, obj);
      if (!status) {
        this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
      }
    },
    previouValueCondition(attr) {
      const notFocus = !this.$_.get(this.commonsRecord.isFocus, attr);
      const notHide = !this.$_.get(this.commonsRecord, "hideRevision"); //hide const use to dectect nil value previous
      const notCondition = !this.$_.get(this.commonsRecord, ["style", attr, "condition"].join("."));
      return notFocus && notHide && notCondition;
    },
    stylePreivous(attr) {
      return this.$_.get(this.commonsRecord, ["style", attr, "previous"].join("."));
    },
    styleLastest(attr) {
      return this.$_.get(this.commonsRecord, ["style", attr, "lastest"].join("."));
    },
    previousValue(attr) {
      return this.$_.get(this.commonsRecord, ["previousItem", attr].join("."));
    },
    isNilPreviousValue(attr) {
      const previousValue = this.$_.get(this.commonsRecord, ["previousItem", attr].join("."), "");
      return previousValue.length != 0;
    },
    calColspan(index) {
      const isColumnFirstAndSecond = index < 2
      return isColumnFirstAndSecond ? 1 : 2;
    },
    showSignatureModal(nameAttribute, dataSignImage, signFor){
      //set order
      this.$store.commit('dashboardRecords/setSignature', {
        order: nameAttribute,
        dataImage: dataSignImage,
        signFor: signFor
      })
      this.$bvModal.show('signature-modal')
    },
    isImageBaseURL(sign){
      return DashboardServices.isImageBaseURL(sign)
    },
    createObjectUrl(presignedUrl) {
      console.log(`createObjectUrl called with: ${presignedUrl}`);

      // presignedUrlがnullまたは空文字列の場合は空文字列を返す
      if (!presignedUrl) return "";

      // presignedUrlがオブジェクトの場合
      if (typeof presignedUrl === "object") {
        // presignedUrlプロパティがある場合はそれを使用
        if (presignedUrl.presignedUrl) {
          console.log(
            `createObjectUrl: using presignedUrl property: ${presignedUrl.presignedUrl}`
          );
          return presignedUrl.presignedUrl;
        }
        // objectKeyプロパティがある場合はそれを使用
        if (presignedUrl.objectKey) {
          console.log(
            `createObjectUrl: using objectKey property: ${presignedUrl.objectKey}`
          );
          return presignedUrl.objectKey;
        }
      }

      // 文字列の場合
      if (typeof presignedUrl === "string") {
        // 既にURLの形式になっている場合はそのまま返す
        const urlPattern = /^(https?:\/\/|blob:|data:)/i;
        if (urlPattern.test(presignedUrl)) {
          console.log(`createObjectUrl: valid URL format: ${presignedUrl}`);
          return presignedUrl;
        }

        // 画像ファイル拡張子を持つ場合
        const imageExtensions = [
          ".png",
          ".jpg",
          ".jpeg",
          ".gif",
          ".bmp",
          ".webp",
          ".svg",
        ];
        for (const ext of imageExtensions) {
          if (presignedUrl.toLowerCase().endsWith(ext)) {
            console.log(`createObjectUrl: image file: ${presignedUrl}`);
            return presignedUrl;
          }
        }
      }

      console.log(`createObjectUrl: returning as is: ${presignedUrl}`);
      return presignedUrl;
    },
  },
};
